import brototype from 'brototype';
const Bro = brototype;

function zPREFACE_Reader(path) {
	let mainKey = window.zPREFACE ? 'zPREFACE':'zPreface';
	return Bro(window).iCanHaz(`${mainKey}.${path}`);
}

export default zPREFACE_Reader;
